import { Media } from '@syconium/little-miss-figgy'
import { User } from '@syconium/little-miss-figgy'

import { useAuthentication } from '../../../../app/_providers/AuthenticationProvider.client'
import { useFeatureFlag } from '../../../../app/_providers/ExperimentationProvider.client'
import { usePreviewDirectives } from '../../../../app/_providers/PreviewDirectivesProvider.client'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { useUser } from '../../../../app/_providers/UserProvider.client'

import { LoggedInTextWrapper, UserInitials, Wrapper } from './styles'

export const AccountTab = () => {
  const { isLoggedIn } = useAuthentication()
  const { user } = useUser()
  const {
    magnolia: {
      account: { navigation: strings },
    },
  } = useTranslation()

  const previewPanelDecision =
    useFeatureFlag<'true' | 'false'>({
      key: 'is-internal-admin',
      controlVariant: 'false',
      ifAccessedPriorToDecisionInitialization: 'return-null-while-pending',
    }) === 'true'

  const { includeUnpublishedCmsContent } = usePreviewDirectives()

  if (!isLoggedIn || !user?.profile.firstName) {
    return <User />
  }

  return (
    <Wrapper>
      {user.profile.lastName ? (
        <UserInitials $highlightBorder={previewPanelDecision && includeUnpublishedCmsContent}>
          {user.profile.firstName[0]}
          {user.profile.lastName[0]}
        </UserInitials>
      ) : (
        <User />
      )}
      <Media greaterThanOrEqual='md'>
        <LoggedInTextWrapper>
          {strings.menu.hi}
          {user.profile.firstName}
        </LoggedInTextWrapper>
      </Media>
    </Wrapper>
  )
}
